const Data = [
    {
        name: "Advait Gokhale ",
        position: "LiGHT Head",
        imageUrl: "/assets/images/members/Heads23/Advait.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100074639880196",
        linkedinLink: "https://www.linkedin.com/in/advait-gokhale-399a0b236/",
        email: "advait.gokhale@gyws.org"
    },
    { 
        name: "Amandeep Randa",
        position: "LiGHT Head",
        imageUrl: "/assets/images/members/Heads23/Amandeep.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Saswat Dash",
        position: "LiGHT Head",
        imageUrl: "/assets/images/members/Heads23/Saswat Dash.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Sumedh Deshkar",
        position: "LiGHT Head",
        imageUrl: "/assets/images/members/Heads23/Sumedh Deshkar.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
   
]

export default Data;